import { jwtDecode } from "jwt-decode";

import type { TokenType } from "@de-common/types/TokenType";
import type { UserData } from "@de-common/types/UserData";
import { UserRole } from "@de-common/types/UserRole";
import { getFromParams } from "./getFromParams";

const KEY = "access_token";

class TokenManager {
  token: string | null;

  constructor() {
    this.token = null;
  }

  getToken() {
    // Fetch token from params if exists otherwise fetch from local-storage
    // TODO: Discuss if we want to move this to a redux state instead of localStorage
    const token = getFromParams("access_token") || localStorage.getItem(KEY);

    if (token) {
      this.setToken(token);
    } else {
      // If token not in params or localStorage, clear memory cache
      this.token = null;
    }

    return this.token;
  }

  getUserData(): UserData | undefined {
    const decodedToken = this.getDecodedToken();
    if (!decodedToken) return undefined;

    const userId = parseInt(decodedToken.sub);
    const userEmail = decodedToken.upn;

    return {
      id: userId,
      email: userEmail,
      isAdmin: this.isAdmin(decodedToken.groups),
      accountId: parseInt(decodedToken.aid),
      roles: decodedToken.groups,
    };
  }

  setToken(token: string) {
    this.token = token;
    localStorage.setItem(KEY, token);
  }

  removeToken() {
    this.token = null;
    localStorage.removeItem(KEY);
  }

  private getDecodedToken(): TokenType | undefined {
    const token = this.getToken();
    if (!token) return undefined;
    return jwtDecode(token);
  }

  private isAdmin = (userRoles: UserRole[]): boolean => {
    return userRoles.some(
      (role) =>
        role === UserRole.SYSTEM_ADMIN ||
        role === UserRole.ACCOUNT_ADMIN ||
        role === UserRole.SUPPORT,
    );
  };
}

const tokenManager = new TokenManager();

export default tokenManager;
